import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);
import theme from './theme';
import navigation from './navigation';
import auth from './auth';
export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    theme,
    navigation,
    auth,
  },
});
